import { PriceValues } from '@thg-commerce/enterprise-pricing/src'

import { ProductVariantItem } from '../../ApolloProvider/resolvers/Types/ProductVariant'
import { FulfilmentMethod } from '../../generated/graphql'
import { getColourSwatches } from '../product/colorSwatch'

const getRrpProductVariant = ({ price, rrp }: PriceValues) => {
  return parseFloat(price.amount) < parseFloat(rrp.amount)
    ? rrp.displayValue
    : null
}

export const productVariantTransformer = (
  productVariant: ProductVariantItem,
) => {
  const productPrice =
    productVariant?.price || productVariant?.product?.cheapestVariant?.price

  return (
    productVariant && {
      __typename: 'ProductVariant',
      title: { __typename: 'productVariantTitle', value: productVariant.title },
      url: productVariant.product?.url || '',
      sku: productVariant.sku,
      externalIdentifier: productVariant.externalIdentifier,
      eligibleForFulfilmentMethods:
        productVariant.eligibleForFulfilmentMethods || null,
      image: {
        __typename: 'productVariantImage',
        urls: {
          __typename: 'productVariantImageUrl',
          largeProduct:
            productVariant.images?.[0]?.largeProduct ||
            productVariant.product?.images?.[0]?.largeProduct ||
            '',
          ...productVariant.images[0],
        },
        altText: '',
        isAmp: false,
      },
      hoverImage:
        productVariant.images.length > 1
          ? {
              __typename: 'productVariantImage',
              urls: {
                __typename: 'productVariantImageUrl',
                largeProduct:
                  productVariant.images?.[1]?.largeProduct ||
                  productVariant.product?.images?.[1]?.largeProduct ||
                  '',
                ...productVariant.images[1],
                thumbnail:
                  productVariant.images?.[1]?.thumbnail ||
                  productVariant.product?.images?.[1]?.thumbnail ||
                  '',
                ...productVariant.images[1],
              },
              altText: '',
              isAmp: false,
            }
          : null,
      review: productVariant.product?.reviews && {
        __typename: 'productVariantReview',
        starRating: productVariant.product.reviews.averageScore,
        numberOfReviews: productVariant.product.reviews.total,
      },
      price: {
        __typename: 'ProductVariantPrice',
        price: {
          defaultPrice: productVariant?.vipPrice
            ? productVariant?.vipPrice?.displayValue
            : productPrice?.price.displayValue || '',
        },
        rrp: {
          __typename: 'ProductVariantRrp',
          defaultPrice: productPrice
            ? getRrpProductVariant(productPrice)
            : null,
        },
      },
      weightGroups: productVariant.weightGroups ?? null,
      isBookable: productVariant.isBookable ?? null,
      leadTime: productVariant.leadTime ?? null,
      inStockLocations: productVariant.inStockLocations ?? null,
      isCheckStock: productVariant.isCheckStock ?? null,
      isOrderInStore: productVariant.isOrderInStore ?? null,
      inStock: productVariant.inStock,
      icons:
        (productVariant.eligibleForFulfilmentMethods && {
          homeDelivery: Boolean(
            productVariant.eligibleForFulfilmentMethods?.includes(
              FulfilmentMethod.HomeDelivery,
            ),
          ),
          storeAvailable: Boolean(
            productVariant.eligibleForFulfilmentMethods?.includes(
              FulfilmentMethod.CollectInStore,
            ),
          ),
          storeDelivery: Boolean(
            productVariant.eligibleForFulfilmentMethods?.includes(
              FulfilmentMethod.DeliverToStore,
            ),
          ),
          __typename: 'ProductDeliveryIcons',
        }) ||
        null,
      colourSwatches:
        productVariant.product && getColourSwatches(productVariant.product),
      marketedSpecialOffer: productVariant.marketedSpecialOffer && {
        __typename: 'productVariantMarketedOffer',
        onlyDisplayOfferBadge: true,
        shouldRemoveScrollLock: false,
        title: productVariant.marketedSpecialOffer.title?.content[0].content,
        description:
          productVariant.marketedSpecialOffer.description?.content[0].content,
        landingPageLink: productVariant.marketedSpecialOffer.landingPageLink
          ? {
              __typename: 'landingPageLink',
              text: productVariant.marketedSpecialOffer.landingPageLink.text,
              url: productVariant.marketedSpecialOffer.landingPageLink.url,
              openExternally:
                productVariant.marketedSpecialOffer.landingPageLink
                  .openExternally,
              noFollow:
                productVariant.marketedSpecialOffer.landingPageLink.noFollow,
            }
          : null,
      },
      brand: {
        name: productVariant.product?.brand?.name,
        imageUrl: productVariant.product?.brand?.imageUrl,
      },
      content: productVariant.content,
    }
  )
}
